import React from "react";
import "./Confirm_Status_Change.css";
import { Button, Modal } from "react-bootstrap";

function Confirm_Status_Change(props) {
  const { message, subMessage } = props;
  return (
    <>
      <div className="Delete_Modal_sec">
        <Modal
          className="Delete_Modal"
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            {" "}
            Do you want to Change Status?
          </Modal.Header>
          <Modal.Body>
            <div className="lottie-holder text text-danger"></div>
            <div className="text-center">
              <Button className="btn btn-danger me-4" onClick={props.onHide}>
                No
              </Button>
              <Button
                className="btn btn-success"
                onClick={() => props.handleStatusChange(props.show)}
              >
                Yes
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Confirm_Status_Change;
